import React, { HTMLProps, ReactNode } from 'react';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { InlineFieldRow } from '../InlineFieldRow/InlineFieldRow';

interface NumberFieldProps extends Omit<HTMLProps<HTMLInputElement>, 'label' | 'onChange' | 'value'> {
    label: ReactNode
    name: string
    value: number | string
    onChange: (event: React.ChangeEvent) => void
    placeholder?: string
    error?: string
    // Label beside the control on one line instead of above it -- opt-in, existing callers are
    // unaffected (Contest V2's EventForm renders this unchanged).
    inline?: boolean
}

export function NumberField(props: NumberFieldProps) {
  const {
    label,
    name,
    value,
    onChange,
    error,
    placeholder,
    min,
    max,
    step,
    inline,
  } = props;

  const control = (
    <InputGroup hasValidation>
      <Form.Control
        type="number"
        id={inline ? name : undefined}
        name={name}
        value={value}
        onChange={onChange}
        isInvalid={!!error}
        placeholder={placeholder}
        min={min}
        max={max}
        step={step}
      />
      <Form.Control.Feedback type="invalid">
        {error}
      </Form.Control.Feedback>
    </InputGroup>
  );

  if (inline) {
    return <InlineFieldRow label={label} htmlFor={name}>{control}</InlineFieldRow>;
  }

  return (
    <Form.Group>
      <Form.Label>{label}</Form.Label>
      {control}
    </Form.Group>
  );
}
